import "core-js/modules/es.reflect.construct.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { useCart } from '~/composables/useCart';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useLocalization } from '~/composables/_next/useLocalization';
var NOTIFICATION_EFFECT = {
  REJECT_COUPON: 'rejectCoupon',
  SHOW_NOTIFICATION: 'showNotification'
};
var COUPON_ERROR_CODE = {
  // codes from talon one
  COUPON_NOT_FOUND: 'CouponNotFound',
  COUPON_LIMIT_REACHED: 'CouponLimitReached',
  COUPON_EXPIRED: 'CouponExpired',
  COUPON_START_DATE_IN_FUTUR: 'CouponStartDateInFutur',
  NON_CUMULATIVE_COUPON: 'CouponPartOfNotTriggeredCampaign',
  // codes custom from our config
  CART_AMOUNT_THRESHOLD: 'cart_amount_treshold',
  INVALID_CART_ITEMS: 'invalid_cart_items',
  DISCOUNTED_ITEMS_FOUND: 'discounted_items_found',
  INVALID_USER: 'invalid_user',
  FIRST_ORDER_ONLY: 'first_order_only',
  INVALID_SHIPPING_METHOD: 'invalid_shipping_method',
  INVALID_SHIPPING_COUNTRY: 'invalid_shipping_country',
  INVALID_DEVICE: 'invalid_device',
  GENERIC_INVALID: 'generic_invalid'
};
var CODE_ERROR_REJECTED_BY_CONDITION = 'CouponRejectedByCondition';
export var CODE_ERROR_DEFAULT_TRANSLATION_KEY = 'checkout.aside.coupon.errors.invalid';
export var CouponCodeError = /*#__PURE__*/function (_Error) {
  function CouponCodeError(_ref) {
    var _this;
    var message = _ref.message,
      code = _ref.code;
    _classCallCheck(this, CouponCodeError);
    _this = _callSuper(this, CouponCodeError, [message]);
    _this.code = code;
    _this.name = 'CouponCodeError';
    return _this;
  }
  _inherits(CouponCodeError, _Error);
  return _createClass(CouponCodeError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export function useCoupon() {
  var _mapTranslation;
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var _useNuxt2App = useNuxt2App(),
    $sentry = _useNuxt2App.$sentry;
  var _useCart = useCart(),
    cart = _useCart.cart,
    setCart = _useCart.setCart,
    addCoupon = _useCart.addCoupon,
    removeCoupon = _useCart.removeCoupon;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale,
    currency = _useLocalization.currency;
  var mapTranslation = (_mapTranslation = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_mapTranslation, COUPON_ERROR_CODE.COUPON_NOT_FOUND, 'checkout.aside.coupon.errorCode.CouponNotFound'), COUPON_ERROR_CODE.COUPON_LIMIT_REACHED, 'checkout.aside.coupon.errorCode.CouponLimitReached'), COUPON_ERROR_CODE.COUPON_EXPIRED, 'checkout.aside.coupon.errorCode.CouponExpired'), COUPON_ERROR_CODE.COUPON_START_DATE_IN_FUTUR, 'checkout.aside.coupon.errorCode.CouponStartDateInFutur'), COUPON_ERROR_CODE.CART_AMOUNT_THRESHOLD, 'checkout.aside.coupon.errorCode.cart_amount_treshold'), COUPON_ERROR_CODE.INVALID_CART_ITEMS, 'checkout.aside.coupon.errorCode.invalid_cart_items'), COUPON_ERROR_CODE.DISCOUNTED_ITEMS_FOUND, 'checkout.aside.coupon.errorCode.discounted_items_found'), COUPON_ERROR_CODE.NON_CUMULATIVE_COUPON, 'checkout.aside.coupon.errorCode.non_cumulative_coupon'), COUPON_ERROR_CODE.INVALID_USER, 'checkout.aside.coupon.errorCode.invalid_user'), COUPON_ERROR_CODE.FIRST_ORDER_ONLY, 'checkout.aside.coupon.errorCode.first_order_only'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_mapTranslation, COUPON_ERROR_CODE.INVALID_SHIPPING_METHOD, 'checkout.aside.coupon.errorCode.invalid_shipping_method'), COUPON_ERROR_CODE.INVALID_SHIPPING_COUNTRY, 'checkout.aside.coupon.errorCode.invalid_shipping_country'), COUPON_ERROR_CODE.INVALID_DEVICE, 'checkout.aside.coupon.errorCode.invalid_device'), COUPON_ERROR_CODE.GENERIC_INVALID, 'checkout.aside.coupon.errorCode.generic_invalid'));
  function updateCartCoupon(_x, _x2) {
    return _updateCartCoupon.apply(this, arguments);
  } // TODO: remove this with feature flag 'enableTalonOne'
  function _updateCartCoupon() {
    _updateCartCoupon = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(action, couponCode) {
      var updatedCart, _cart$value, _cart$value2, _cart$value3, _cart$value4;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (!(action === 'apply')) {
              _context2.next = 7;
              break;
            }
            _context2.next = 4;
            return client.coupon.applyCoupon.mutate({
              locale: locale,
              currency: currency,
              version: (_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.version,
              cartId: (_cart$value2 = cart.value) === null || _cart$value2 === void 0 ? void 0 : _cart$value2.id,
              couponCode: couponCode
            });
          case 4:
            updatedCart = _context2.sent;
            _context2.next = 10;
            break;
          case 7:
            _context2.next = 9;
            return client.coupon.removeCoupon.mutate({
              locale: locale,
              currency: currency,
              version: (_cart$value3 = cart.value) === null || _cart$value3 === void 0 ? void 0 : _cart$value3.version,
              cartId: (_cart$value4 = cart.value) === null || _cart$value4 === void 0 ? void 0 : _cart$value4.id,
              couponCode: couponCode
            });
          case 9:
            updatedCart = _context2.sent;
          case 10:
            updatedCart && setCart(updatedCart);
            return _context2.abrupt("return", updatedCart);
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](0);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('updateCartCoupon', {
              action: action,
              couponCode: couponCode
            });
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context2.t0);
            throw _context2.t0;
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 14]]);
    }));
    return _updateCartCoupon.apply(this, arguments);
  }
  function legacyApplyCartCoupon(_x3) {
    return _legacyApplyCartCoupon.apply(this, arguments);
  } // TODO: remove this with feature flag 'enableTalonOne'
  function _legacyApplyCartCoupon() {
    _legacyApplyCartCoupon = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(couponCode) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return addCoupon(couponCode);
          case 3:
            _context3.next = 10;
            break;
          case 5:
            _context3.prev = 5;
            _context3.t0 = _context3["catch"](0);
            $sentry.setContext('legacyApplyCartCoupon', {
              couponCode: couponCode
            });
            $sentry.captureException(_context3.t0);
            throw _context3.t0;
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 5]]);
    }));
    return _legacyApplyCartCoupon.apply(this, arguments);
  }
  function legacyRemoveCartCoupon(_x4) {
    return _legacyRemoveCartCoupon.apply(this, arguments);
  }
  function _legacyRemoveCartCoupon() {
    _legacyRemoveCartCoupon = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(couponId) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return removeCoupon(couponId);
          case 3:
            _context4.next = 10;
            break;
          case 5:
            _context4.prev = 5;
            _context4.t0 = _context4["catch"](0);
            $sentry.setContext('legacyRemoveCartCoupon', {
              couponId: couponId
            });
            $sentry.captureException(_context4.t0);
            throw _context4.t0;
          case 10:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 5]]);
    }));
    return _legacyRemoveCartCoupon.apply(this, arguments);
  }
  return {
    applyCartCoupon: function applyCartCoupon(couponCode) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _cart$custom, _cart$custom$customFi;
        var cart, talonOneCartNotifications, _couponNotifications$, parsedNotifications, couponNotifications, couponNotification, isAcceptedCoupon, _mapTranslation$coupo, couponNotificationShow, translationKey, _translationKey;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return updateCartCoupon('apply', couponCode);
            case 2:
              cart = _context.sent;
              talonOneCartNotifications = (_cart$custom = cart.custom) === null || _cart$custom === void 0 ? void 0 : (_cart$custom$customFi = _cart$custom.customFieldsRaw.find(function (_ref2) {
                var name = _ref2.name;
                return name === 'talon_one_cart_notifications';
              })) === null || _cart$custom$customFi === void 0 ? void 0 : _cart$custom$customFi.value;
              if (!talonOneCartNotifications) {
                _context.next = 21;
                break;
              }
              parsedNotifications = JSON.parse(talonOneCartNotifications);
              couponNotifications = parsedNotifications.filter(function (_ref3) {
                var body = _ref3.body;
                return body.toLowerCase() === couponCode.toLowerCase();
              });
              couponNotification = (_couponNotifications$ = couponNotifications[0]) !== null && _couponNotifications$ !== void 0 ? _couponNotifications$ : null;
              isAcceptedCoupon = couponNotifications.some(function (_ref4) {
                var effect = _ref4.effect;
                return effect === 'acceptCoupon';
              });
              if (!(!isAcceptedCoupon && (couponNotification === null || couponNotification === void 0 ? void 0 : couponNotification.effect) === NOTIFICATION_EFFECT.REJECT_COUPON)) {
                _context.next = 21;
                break;
              }
              if (!((couponNotification === null || couponNotification === void 0 ? void 0 : couponNotification.code) === CODE_ERROR_REJECTED_BY_CONDITION)) {
                _context.next = 16;
                break;
              }
              couponNotificationShow = parsedNotifications.find(function (_ref5) {
                var effect = _ref5.effect;
                return effect === NOTIFICATION_EFFECT.SHOW_NOTIFICATION;
              });
              translationKey = (_mapTranslation$coupo = mapTranslation[couponNotificationShow === null || couponNotificationShow === void 0 ? void 0 : couponNotificationShow.body]) !== null && _mapTranslation$coupo !== void 0 ? _mapTranslation$coupo : CODE_ERROR_DEFAULT_TRANSLATION_KEY;
              throw new CouponCodeError({
                message: 'coupon rejected by condition',
                code: translationKey
              });
            case 16:
              if (!mapTranslation[couponNotification === null || couponNotification === void 0 ? void 0 : couponNotification.code]) {
                _context.next = 20;
                break;
              }
              _translationKey = mapTranslation[couponNotification === null || couponNotification === void 0 ? void 0 : couponNotification.code];
              if ((couponNotification === null || couponNotification === void 0 ? void 0 : couponNotification.code) === COUPON_ERROR_CODE.COUPON_NOT_FOUND) {
                _translationKey = CODE_ERROR_DEFAULT_TRANSLATION_KEY;
              }
              throw new CouponCodeError({
                message: 'coupon rejected with code',
                code: _translationKey
              });
            case 20:
              throw new Error('rejectCoupon');
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    removeCartCoupon: function removeCartCoupon(couponCode) {
      return updateCartCoupon('remove', couponCode);
    },
    legacyApplyCartCoupon: legacyApplyCartCoupon,
    legacyRemoveCartCoupon: legacyRemoveCartCoupon
  };
}